import React from 'react';
import { Helmet } from 'react-helmet';

var NotFoundScreen = function NotFoundScreen() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Not Found")), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "mt-4"
  }, "Page Not Found")));
};

export { NotFoundScreen };